<div class="parametre-db-wrap parametre-db-layout" [class.parametre-db--embedded]="embedInParent">
  <div *ngIf="!hidePageHeader" class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h5 class="mb-0 parametre-db-title">Paramètres des données</h5>
      <p class="mb-0 parametre-db-section-hint">{{ sectionTitle }}</p>
    </div>
    <span *ngIf="loading" class="text-muted small">Chargement…</span>
  </div>
  <div *ngIf="hidePageHeader && loading" class="d-flex justify-content-end mb-2">
    <span class="text-muted small">Chargement…</span>
  </div>

  <form (ngSubmit)="$event.preventDefault()" autocomplete="off" novalidate>
  <div class="parametre-db-rows" [attr.aria-busy]="loading">
    <div
      *ngFor="let p of parametres; let i = index"
      class="d-flex flex-wrap align-items-end parametre-db-line mb-3">
      <div class="parametre-db-libelle mr-md-3 mb-2 mb-md-0">
        <label class="parametre-db-label d-block" [attr.for]="'libelle-' + i">Libellé</label>
        <input
          type="text"
          class="form-control"
          [id]="'libelle-' + i"
          [name]="'libelle-' + i"
          [(ngModel)]="p.libelle"
          placeholder="Libellé du paramètre"
          autocomplete="off"
          [disabled]="loading">
      </div>
      <div class="parametre-db-type mb-2 mb-md-0">
        <label class="parametre-db-label d-block" [attr.for]="'type-' + i">Type</label>
        <ng-select
          [inputId]="'type-' + i"
          [items]="typeOptions"
          bindLabel="label"
          bindValue="value"
          [(ngModel)]="p.type"
          [name]="'type-' + i"
          [clearable]="false"
          [disabled]="loading"
          placeholder="Type"
          class="ng-select-custom parametre-db-type-select">
        </ng-select>
      </div>
      <div class="parametre-db-actions ml-md-2 mb-2 mb-md-0" *ngIf="parametres.length > 1">
        <button
          type="button"
          class="parametre-db-remove-btn"
          [disabled]="loading"
          (click)="supprimerLigne(i)"
          title="Supprimer cette ligne"
          aria-label="Supprimer cette ligne">
          <span class="parametre-db-remove-minus" aria-hidden="true"></span>
        </button>
      </div>
    </div>
  </div>
  </form>

  <div class="mt-2">
    <button type="button" class="btn btn-link parametre-db-add px-0" [disabled]="loading" (click)="ajouterParametre()">
      Ajouter un paramètre
    </button>
  </div>

  <div class="parametre-db-save-footer">
    <button
      type="button"
      class="btn btn-primary parametre-db-save"
      [disabled]="saving || loading"
      (click)="enregistrer()">
      {{ saving ? 'Enregistrement…' : 'Enregistrer' }}
    </button>
  </div>
</div>
